export default "__VITE_ASSET__DpvlK3s$__"